import { PLATFORM_ID, inject, REQUEST, DOCUMENT } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export function cookiesFactory(): string {
  const platformId = inject(PLATFORM_ID);

  // Browser: use document.cookie
  if (isPlatformBrowser(platformId)) {
    const document = inject(DOCUMENT);
    return document.cookie;
  }

  // Server: use request headers
  const req = inject(REQUEST, { optional: true }) as any;
  return req?.headers?.get?.('cookie') ?? req?.headers?.cookie ?? '';
}


